import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class WhoisService {
    checkLocal(params) {
        return axios.get(API_URL + 'whois/detail', {params: params,
            headers: authHeader() });
    }
    saveWhois(data) {
        return axios.post(API_URL + 'whois', data, {
            headers: authHeader() });
    }

    // reputation(api_host, params, headers) {
    //     return axios.get(api_host, { params: params, headers: headers });
    // }
   
}

export default new WhoisService();
